/* eslint-disable */
// 優化程式碼版(半年後若沒問題，建議把相同檔名有_的刪除)
// 20250428
export function autoLinks(origText = '') {
   if (!origText) return '';

   const urlReg = /\b((https?|ftp):\/\/[^\s<>"']+)/gi,
      emailReg = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

   // 第一步：先替換網址
   let resultText = origText.replace(urlReg, (match) => {
      // 確保不要包到多餘符號
      const cleanUrl = match.replace(/[\.,;]*$/, '');

      return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>`;
   });

   // 第二步：再替換 email
   resultText = resultText.replace(emailReg, (match) => {
      return `<a href="mailto:${match}">${match}</a>`;
   });

   return resultText;
   // 請參考 https://ww.wfublog.com/2015/08/url-string-auto-convert-to-hyperlink.html#section2
}


// WEBPACK FOOTER //
// ./src/commonJS/autoLinks.js